import { Injectable } from '@angular/core';
import { IAppDataStore } from '../interfaces/app-data-store.abstract.service';

@Injectable()
export class AppDataStore implements IAppDataStore {
    private store: any = {};

    constructor() {
    }

    get(key: string): any {
        return this.store[key];
    }

    put(key: string, value: any) {
        this.store[key] = value;
    }

    clearAll() {
        this.store = {};
    }

}
